var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.813 2.40601L5.405 3.81201L7.5 5.90601L8.906 4.50001L6.812 2.40601H6.813ZM25.188 2.40601L23.093 4.50001L24.5 5.90601L26.594 3.81301L25.188 2.40601ZM16 3.03001C15.67 3.03401 15.336 3.05301 15 3.09401C14.99 3.09401 14.98 3.09201 14.97 3.09401C10.914 3.55901 7.686 6.83601 7.125 10.874C6.677 14.124 8.017 17.071 10.25 18.969C11.1634 19.7485 11.7812 20.8183 12 21.999V27.999H14.28C14.628 28.596 15.263 28.999 16 28.999C16.737 28.999 17.372 28.596 17.72 27.999H20V23.999H20.094V22.811C20.094 21.345 20.856 19.867 22.094 18.718C23.75 17.06 25 14.705 25 12C25 7.06001 20.934 2.98401 16 3.03001ZM16 5.03001C19.865 4.97601 23 8.14001 23 12C23 14.094 22.03 15.938 20.687 17.28L20.719 17.312C19.3844 18.5427 18.5214 20.2008 18.279 22H13.905C13.685 20.286 12.95 18.627 11.561 17.437C9.794 15.937 8.741 13.677 9.093 11.125C9.53 7.97501 12.086 5.44201 15.218 5.09501C15.4766 5.05895 15.737 5.03759 15.998 5.03101L16 5.03001ZM2 12V14H5V12H2ZM27 12V14H30V12H27ZM7.5 20.094L5.406 22.187L6.813 23.594L8.905 21.5L7.5 20.094ZM24.5 20.094L23.094 21.5L25.187 23.594L26.594 22.187L24.5 20.094ZM14 24H18V26H14V24Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.90c38844a95e1f0626affdfc02a3af18.svg";
export { ForwardRef as ReactComponent };